import { createRequestActionTypes } from '../../helpers'

export const SEND_EMAIL = createRequestActionTypes(
  'CONTENT_MAILER',
  'SEND_EMAIL'
)
